module.exports = __webpack_public_path__ + "img/brifecase-timer.70879242.svg";